import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
import FilterOperator from '@/constants/forms/FilterOperator';
import type FieldOperatorMap from '@/types/FieldOperatorMap';

const {
  IS,
  IS_NOT,
  IS_NULL,
  IS_NOT_NULL,
  CONTAINS,
  NOT_CONTAINS,
  ANY,
  ALL,
  NONE_OF,
  GREATER_THAN,
  LESS_THAN,
  BETWEEN,
} = FilterOperator;

const FieldOperatorsMap: FieldOperatorMap = {
  [ConstituentSearchFilterField.NAME_EMAIL_PHONE]: [IS],
  [ConstituentSearchFilterField.CITY]: [
    CONTAINS,
    NOT_CONTAINS,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.STATE]: [IS, IS_NOT, IS_NOT_NULL, IS_NULL],
  [ConstituentSearchFilterField.POSTAL_CODE]: [
    IS,
    IS_NOT,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.COUNTRY]: [ANY, NONE_OF, IS_NOT_NULL, IS_NULL],
  [ConstituentSearchFilterField.USER_IDS]: [IS, IS_NOT, IS_NOT_NULL, IS_NULL],
  [ConstituentSearchFilterField.CONSTITUENT_CATEGORIES]: [
    ALL,
    ANY,
    NONE_OF,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.CONSTITUENT_LABEL_IDS]: [
    ALL,
    ANY,
    NONE_OF,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.BIRTHDAY_MONTH]: [IS],
  [ConstituentSearchFilterField.DOB]: [
    GREATER_THAN,
    LESS_THAN,
    IS_NOT_NULL,
    IS_NULL,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.BOARD_IDS]: [
    ANY,
    ALL,
    NONE_OF,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.COLUMN_IDS]: [ANY, NONE_OF],
  [ConstituentSearchFilterField.CONNECTION_EMPLOYER_CONSTITUENT_IDS]: [
    IS,
    IS_NOT,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.CONNECTION_HOUSEHOLD_CONSTITUENT_IDS]: [
    IS,
    IS_NOT,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.CONNECTION_CONSTITUENT_IDS]: [
    IS,
    IS_NOT,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.IS_DECEASED]: [IS],
  [ConstituentSearchFilterField.DONATION_TYPES]: [ANY, NONE_OF],
  [ConstituentSearchFilterField.CAMPAIGN_IDS]: [
    ANY,
    ALL,
    NONE_OF,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_AMOUNT]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_TIME]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_AMOUNT]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_TIME]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_AMOUNT]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_TIME]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_AMOUNT]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_MINUTES]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_PLAN_CADENCE]: [IS],
  [ConstituentSearchFilterField.IN_HONOR]: [CONTAINS, IS_NOT_NULL, IS_NULL],
  [ConstituentSearchFilterField.DONATION_DATE]: [
    IS,
    GREATER_THAN,
    LESS_THAN,
    BETWEEN,
  ],
  [ConstituentSearchFilterField.DONATION_MADE]: [IS],
  [ConstituentSearchFilterField.DONATION_LABEL_IDS]: [
    ALL,
    ANY,
    NONE_OF,
    IS_NOT_NULL,
    IS_NULL,
  ],

  // Custom fields
  [CustomFieldTypes.CHECKBOX]: [IS],
  [CustomFieldTypes.DATE_PICKER]: [
    GREATER_THAN,
    LESS_THAN,
    IS_NOT_NULL,
    IS_NULL,
    BETWEEN,
  ],
  [CustomFieldTypes.LIST_SINGLE]: [ANY, ALL, NONE_OF, IS_NOT_NULL, IS_NULL],
  [CustomFieldTypes.LIST_MULTI]: [ANY, ALL, NONE_OF, IS_NOT_NULL, IS_NULL],
  [CustomFieldTypes.TEXT_SINGLE]: [
    CONTAINS,
    NOT_CONTAINS,
    IS_NOT_NULL,
    IS_NULL,
  ],
  [CustomFieldTypes.TEXT_MULTI]: [CONTAINS, NOT_CONTAINS, IS_NOT_NULL, IS_NULL],

  // TODO(jon): Below are placeholders for potential query builder options.
  [ConstituentSearchFilterField.HAS_ASSIGNEES]: [IS],
  [ConstituentSearchFilterField.CONSTITUENT_RULES]: [IS],
  [ConstituentSearchFilterField.DONATION_DATE_TYPE]: [IS],
  [ConstituentSearchFilterField.CONSTITUENT_TYPE]: [IS],
};

export default FieldOperatorsMap;
